import React from 'react';

import { Locales } from 'src/lib/constants';
import { TemplateSwitch } from 'src/templates';
import {
  getResourcesArticleStaticPaths,
  getResourcesArticleStaticProps,
} from 'src/lib/resources-page-data';

const Article = (props) => {
  return <TemplateSwitch {...props} locale={Locales.EN_GB} />;
};

export async function getStaticPaths() {
  return getResourcesArticleStaticPaths({ locale: Locales.EN_GB });
}

export async function getStaticProps({ params, preview }) {
  return getResourcesArticleStaticProps({
    locale: Locales.EN_GB,
    preview,
    params,
  });
}

export default Article;
